import {
  peopleSelectControlSx,
  peopleSelectMenuProps,
  peopleScrollSelectMenuProps,
  peopleSelectSx,
} from "../peopleSelectStyles";

export const TEAM_FORM_WIDTH = 632;

export const TEAM_TEXTAREA_MIN_ROWS = 3;
export const TEAM_TEXTAREA_MAX_ROWS = 8;

export { peopleSelectControlSx, peopleSelectMenuProps, peopleSelectSx };

/**
 * Scrollable MUI Select menu for team group dropdowns (224px max height).
 * @param {{ placement?: "bottom" | "top" }} [opts]
 *   Use `placement: "top"` in modals so the menu stays inside the popup.
 */
export function teamGroupSelectMenuProps({ placement = "bottom" } = {}) {
  const base = peopleScrollSelectMenuProps();
  if (placement !== "top") return base;

  return {
    ...base,
    anchorOrigin: { vertical: "top", horizontal: "left" },
    transformOrigin: { vertical: "bottom", horizontal: "left" },
    PaperProps: {
      ...base.PaperProps,
      sx: {
        ...base.PaperProps.sx,
        marginTop: 0,
        marginBottom: "8px",
      },
    },
  };
}

export const fieldLabelSx = {
  color: "#405261",
  fontFamily: "Inter",
  fontSize: 12,
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "normal",
  mb: 0.75,
};

const inputRootSx = {
  borderRadius: "8px",
  background: "#FFF",
  boxShadow: "0 1px 2px 0 rgba(6, 21, 34, 0.05)",
  fontFamily: "Inter",
  fontSize: 14,
  "& fieldset": { border: "1px solid #D5DCE1" },
  "&:hover fieldset": { border: "1px solid #D5DCE1" },
  "&.Mui-focused fieldset": { border: "1px solid #D5DCE1" },
};

export const inputSx = {
  width: TEAM_FORM_WIDTH,
  maxWidth: "100%",
  "& .MuiOutlinedInput-root": {
    ...inputRootSx,
    height: 40,
  },
  "& .MuiOutlinedInput-input": {
    py: 0,
    px: 1.5,
    height: 40,
    boxSizing: "border-box",
    "&::placeholder": { color: "#C5CED6", opacity: 1 },
  },
};

export const textareaSx = {
  width: TEAM_FORM_WIDTH,
  maxWidth: "100%",
  "& .MuiOutlinedInput-root": {
    ...inputRootSx,
    minHeight: 96,
    maxHeight: 200,
    alignItems: "flex-start",
    py: 1,
    overflow: "auto",
  },
  "& .MuiOutlinedInput-input": {
    py: 0,
    height: "auto !important",
    minHeight: 72,
    boxSizing: "border-box",
    wordBreak: "break-word",
    overflowWrap: "anywhere",
    "&::placeholder": { color: "#C5CED6", opacity: 1 },
  },
  "& textarea": {
    wordBreak: "break-word",
    overflowWrap: "anywhere",
  },
};

export const selectSx = peopleSelectControlSx({
  width: TEAM_FORM_WIDTH,
  maxWidth: "100%",
});

export const pageTitleSx = {
  color: "#061522",
  fontFamily: "Inter",
  fontSize: 24,
  fontStyle: "normal",
  fontWeight: 500,
  lineHeight: "34px",
};

export const pageSubtitleSx = {
  color: "#405261",
  fontFamily: "Inter",
  fontSize: 16,
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "18px",
  mt: 0.5,
};
